import dayjs from "dayjs";
import * as yup from "yup";

export const emptylocalizacaoCarga = {
  localizacao: "",
  cidade: "",
  estado: "",
  quantidade: null,
};

export const emptyDetalheLoteDto = {
  //  id: "",
  gtinEan: "",
  sku: "",
  descricao: "",
  categoria: "",
  lote: "",
  unidades: 0,
  dataValidade: "",
  urlImagens: "",
  quantidadePorCaixa: "",
  caixaPallet: "",
  loteMinimo: "",
  tipoFrete: "",
  precoUnidade: null,
  estoqueDisponivelCaixas: "",
  pedidoMinimo: null,
  precoVenda_NF_PorCaixa: "",
  feeGreeners: "",
  feeGreenersPrecoMedioVarejo: "",
  descontoAplicado: null,
  observacoes: "",
  motivoOferta: "",
  outro: "",
  oportunidadeId: "",
  localizacaoCarga: [emptylocalizacaoCarga],
};

export const editarOportunidadeValidator = (statusDeal) => {
  return yup.object().shape({
    statusDeal: yup.string().required(),
    detalheLoteDto: yup.array().of(
      yup.object().shape({
        gtinEan:
          statusDeal !== 1
            ? yup.string().required("Campo obrigatório")
            : yup.string(),
        motivoOferta:
          statusDeal !== 1
            ? yup
              .string()
              .transform((value) => (value === null ? "" : value))
              .required("Campo obrigatório")
            : yup.string().transform((value) => (value === null ? "" : value)),
        outro: yup.string().when("motivoOferta", {
          is: (motivoOferta) => motivoOferta === "Outro",
          then: yup.string().required("Campo obrigatório"),
          otherwise: yup.string(),
        }),
        pedidoMinimo: yup
          .number()
          .min(0, "Não é permitido números negativos")
          .nullable(),
        estoqueDisponivelCaixas:
          statusDeal !== 1
            ? yup
              .number()
              .transform((value) => (isNaN(value) ? undefined : value))
              .min(0, "Não é permitido números negativos")
              .required("Campo obrigatório")
            : yup
              .number()
              .transform((value) => (isNaN(value) ? undefined : value))
              .min(0, "Não é permitido números negativos"),
        descontoAplicado:
          statusDeal !== 1
            ? yup
              .number()
              .transform((value) => (isNaN(value) ? undefined : value))
              .min(0, "Não é permitido números negativos")
              .max(100, "Não é permitido números acima de 100")
              .required("Campo obrigatório")
            : yup
              .number()
              .transform((value) => (isNaN(value) ? undefined : value))
              .min(0, "Não é permitido números negativos")
              .max(100, "Não é permitido números acima de 100"),
        precoVenda_NF_PorCaixa:
          statusDeal !== 1
            ? yup
              .string()
              .transform((value) => (value === null ? "" : value))
              .required("Campo obrigatório")
            : yup.string().transform((value) => (value === null ? "" : value)),
        feeGreeners:
          statusDeal !== 1
            ? yup
              .number()
              .transform((value) => (isNaN(value) ? undefined : value))
              .required("Campo obrigatório")
            : yup.number().notRequired().nullable(),
        feeGreenersPrecoMedioVarejo:
          statusDeal !== 1
            ? yup
              .number()
              .transform((value) => (isNaN(value) ? undefined : value))
              .required("Campo obrigatório")
            : yup.number().notRequired().nullable(),
        //localizacaoCarga: yup.array().of(
        //  yup.object().shape({
        //    quantidade:
        //      statusDeal !== 1
        //        ? yup
        //            .number()
        //            .transform((value) => (isNaN(value) ? undefined : value))
        //            .min(0, "Não é permitido números negativos")
        //            .required("Campo obrigatório")
        //        : yup
        //            .number()
        //            .transform((value) => (isNaN(value) ? null : value))
        //            .min(0, "Não é permitido números negativos")
        //            .nullable(),
        //  })
        //),
      })
    ),
  });
};

export const formOportunidadeInitialState = () => ({
  dataAbertura: new Date(),
  codigo: "",
  statusDeal: 1,
  totalSKU: 1,
  dadosEmpresaSellerId: "",
  nomeFantasia: "",
  detalheLoteDto: new Array(emptyDetalheLoteDto),
  nomeOportunidade: "",
});

export const mapearResponseApi = (oportunidade) => {
  let response = {
    nomeCompleto: oportunidade.nomeCompleto,
    nomeFantasia: oportunidade.nomeFantasia,
    idOportunidade: oportunidade.id,
    codigo: oportunidade.codigo,
    dataAbertura: oportunidade.dataAbertura,
    motivoOferta: oportunidade.motivoOferta,
    statusDeal: oportunidade.statusDeal,
    userId: oportunidade.userId,
    dadosEmpresaSellerId: oportunidade.dadosEmpresaSellerId,
  };

  if (oportunidade.detalheLoteDto) {
    response.idDetalhesOportunidade = oportunidade.detalheLoteDto?.id;
    response.gtinEan = oportunidade.detalheLoteDto?.gtinEan;
    response.sku = oportunidade.detalheLoteDto?.sku;
    response.descricao = oportunidade.detalheLoteDto?.descricao;
    response.categoria = oportunidade.detalheLoteDto?.categoria;
    response.lote = oportunidade.detalheLoteDto?.lote;
    response.unidades = oportunidade.detalheLoteDto?.unidades;
    response.dataValidade = oportunidade.detalheLoteDto?.dataValidade;
    response.urlImagens = oportunidade.detalheLoteDto?.urlImagens;
    response.quantidadePorCaixa = oportunidade.detalheLoteDto?.quantidadePorCaixa;
    response.peso = oportunidade.detalheLoteDto?.peso;
    response.dimessaoCaixa = oportunidade.detalheLoteDto?.dimessaoCaixa;
    response.caixaPallet = oportunidade.detalheLoteDto?.caixaPallet;
    response.loteMinimo = oportunidade.detalheLoteDto?.loteMinimo;
    response.tipoFrete = oportunidade.detalheLoteDto?.tipoFrete;
    response.precoUnidade = oportunidade.detalheLoteDto?.precoUnidade;
    response.precoDisplay = oportunidade.detalheLoteDto?.precoDisplay;
    response.precoCaixa = oportunidade.detalheLoteDto?.precoCaixa;
    response.precoConsumidor = oportunidade.detalheLoteDto?.precoConsumidor;
    response.precoTotalLote = oportunidade.detalheLoteDto?.precoTotalLote;
    response.precoMinimo = oportunidade.detalheLoteDto?.precoMinimo;
    response.descontoMaximo = oportunidade.detalheLoteDto?.descontoMaximo;
  } else {
    response.idDetalhesOportunidade = "";
    response.gtinEan = "";
    response.sku = "";
    response.descricao = "";
    response.categoria = "";
    response.lote = "";
    response.unidades = "";
    response.urlImagens = "";
    response.quantidadePorCaixa = 0;
    response.peso = 0;
    response.dimessaoCaixa = "";
    response.caixaPallet = 0;
    response.loteMinimo = "";
    response.tipoFrete = "";
    response.precoUnidade = "0";
    response.precoDisplay = "0";
    response.precoCaixa = "0";
    response.precoConsumidor = "0";
    response.precoTotalLote = "0";
    response.precoMinimo = "0";
    response.descontoMaximo = "0";
  }

  if (oportunidade.produtoOportunideResponseDto) {
    response = {
      ...response,
      descricao: oportunidade.produtoOportunideResponseDto?.descricao,
      descricaoLonga:
        oportunidade.produtoOportunideResponseDto?.descricaoLonga ||
        "Não se aplica!",
      gpc: oportunidade.produtoOportunideResponseDto.gpc,
      descricaoNcm: oportunidade.produtoOportunideResponseDto.descricaoNcm,
      marca: oportunidade.produtoOportunideResponseDto.marca,
      fabricante: oportunidade.produtoOportunideResponseDto.fabricante,
      produtoUrlImagem:
        oportunidade.produtoOportunideResponseDto.produtoUrlImagem || "",
      quantidadeUnidade:
        oportunidade.produtoOportunideResponseDto.quantidadeUnidade,
      alturaUnidade: oportunidade.produtoOportunideResponseDto.alturaUnidade,
      larguraUnidade: oportunidade.produtoOportunideResponseDto.larguraUnidade,
      profundidadeUnidade:
        oportunidade.produtoOportunideResponseDto.profundidadeUnidade,
      pesoBrutoUnidade:
        oportunidade.produtoOportunideResponseDto.pesoBrutoUnidade,
      pesoLiquidoUnidade:
        oportunidade.produtoOportunideResponseDto.pesoLiquidoUnidade,
      volumeUnidade: oportunidade.produtoOportunideResponseDto.volumeUnidade,
      gtinDun14Caixa: oportunidade.produtoOportunideResponseDto.gtinDun14Caixa,
      quantidadePorCaixa:
        oportunidade.produtoOportunideResponseDto.quantidadePorCaixa,
      alturaCaixa: oportunidade.produtoOportunideResponseDto.alturaCaixa,
      larguraCaixa: oportunidade.produtoOportunideResponseDto.larguraCaixa,
      profundidadeCaixa:
        oportunidade.produtoOportunideResponseDto.profundidadeCaixa,
      volumeCaixa: oportunidade.produtoOportunideResponseDto.volumeCaixa,
      pesoBrutoCaixa: oportunidade.produtoOportunideResponseDto.pesoBrutoCaixa,
      pesoLiquidoCaixa:
        oportunidade.produtoOportunideResponseDto.pesoLiquidoCaixa,
      quantidadeDeCaixaPorPallet:
        oportunidade.produtoOportunideResponseDto.quantidadeDeCaixaPorPallet,
      alturaPallet: oportunidade.produtoOportunideResponseDto.alturaPallet,
      larguraPallet: oportunidade.produtoOportunideResponseDto.larguraPallet,
      profundidadePallet:
        oportunidade.produtoOportunideResponseDto.profundidadePallet,
      pesoBrutoPallet:
        oportunidade.produtoOportunideResponseDto.pesoBrutoPallet,
      pesoLiquidoPallet:
        oportunidade.produtoOportunideResponseDto.pesoLiquidoPallet,
      volumePallet: oportunidade.produtoOportunideResponseDto.volumePallet,
      validade: oportunidade.produtoOportunideResponseDto.validade,
      lote: oportunidade.produtoOportunideResponseDto.lote || "",
      quantidadeTotalPallets:
        oportunidade.produtoOportunideResponseDto.quantidadeTotalPallets,
      pesoTotal: oportunidade.produtoOportunideResponseDto.pesoTotal,
      pesoMinimoCaixas:
        oportunidade.produtoOportunideResponseDto.pesoMinimoCaixas,
      tipoFrete: oportunidade.produtoOportunideResponseDto.tipoFrete,
      precoTabelaUnidade:
        oportunidade.produtoOportunideResponseDto.precoTabelaUnidade,
      precoTabelaDisplay:
        oportunidade.produtoOportunideResponseDto.precoTabelaDisplay,
      precoTabelaCaixa:
        oportunidade.produtoOportunideResponseDto.precoTabelaCaixa,
      precoSugeridoCaixa:
        oportunidade.produtoOportunideResponseDto.precoSugeridoCaixa,
      precoPorCaixaSemImpostos:
        oportunidade.produtoOportunideResponseDto.precoPorCaixaSemImpostos,
      impostosPorCaixa:
        oportunidade.produtoOportunideResponseDto.impostosPorCaixa,
      valorPorCaixaNFSeller:
        oportunidade.produtoOportunideResponseDto.valorPorCaixaNFSeller,
      descontoAplicado:
        oportunidade.produtoOportunideResponseDto.descontoAplicado,
      feeGreeners: oportunidade.produtoOportunideResponseDto.feeGreeners,
      feeGreenersValor:
        oportunidade.produtoOportunideResponseDto.feeGreenersValor,
      markupPorCaixa: oportunidade.produtoOportunideResponseDto.markupPorCaixa,
      markupPorUnidade:
        oportunidade.produtoOportunideResponseDto.markupPorUnidade,
      precoTotalDoLote:
        oportunidade.produtoOportunideResponseDto.precoTotalDoLote,
    };
  }

  if (oportunidade.localizacaoCarga) {
    response.localizacaoCarga = oportunidade.localizacaoCarga.length
      ? oportunidade.localizacaoCarga
      : [emptylocalizacaoCarga];
  }

  return response;
};

export const mapearStatusDeal = (value) => {
  switch (value) {
    case 1:
      return "Rascunho";
    case 2:
      return "Novo";
    case 3:
      return "Negociação";
    case 4:
      return "Finalizado";
    default:
      return "";
  }
};

export const mapearData = (oportunidade, localizacaoCarga) => {
  let data = {
    id: oportunidade.idOportunidade,
    motivoOferta: oportunidade.motivoOferta,
    statusDeal: oportunidade.statusDeal,
    userId: oportunidade.userId,
    dadosEmpresaSellerId: oportunidade.dadosEmpresaSellerId,
    urlImagens: oportunidade.urlImagens,
    dataValidade: oportunidade.dataValidade,

    detalheLoteDto:
      oportunidade.gtinEan != ""
        ? {
          gtinEan: oportunidade.gtinEan,
          sku: oportunidade.sku,
          descricao: oportunidade.descricao,
          categoria: oportunidade.categoria,
          lote: oportunidade.lote,
          unidades: oportunidade.unidades,
          dataValidade: oportunidade.dataValidade,
          urlImagens: oportunidade.urlImagens,
          quantidadePorCaixa: oportunidade.quantidadePorCaixa,
          peso: oportunidade.peso,
          dimessaoCaixa: oportunidade.dimessaoCaixa,
          caixaPallet: oportunidade.caixaPallet,
          loteMinimo: oportunidade.loteMinimo,
          tipoFrete: oportunidade.tipoFrete,
          precoUnidade: oportunidade.precoUnidade,
          precoDisplay: oportunidade.precoDisplay,
          precoCaixa: oportunidade.precoCaixa,
          precoConsumidor: oportunidade.precoConsumidor,
          precoTotalLote: oportunidade.precoTotalLote,
          precoMinimo: oportunidade.precoMinimo,
          descontoMaximo: oportunidade.descontoMaximo,
        }
        : null,
    localizacaoCarga: localizacaoCarga != null ? localizacaoCarga : null,
  };

  return data;
};

export const mapDataToSent = (values) => ({
  id: values?.id || undefined,
  codigo: values?.codigo,
  dataAbertura: dayjs().format("YYYY-MM-DD"),
  descricaoNcm: values.ncm,
  statusDeal: values.statusDeal,
  motivoOfertaId: values?.motivoOferta ?? null,
  statusOfertaId: values?.statusOferta ?? null,
  dadosEmpresaSellerId: values.dadosEmpresaSellerId,
  nomeOportunidade: values.nomeOportunidade,
  linkOportunidade: values.linkOportunidade,
  produtoOportunideResponseDto: undefined,
  userId: values?.userId || undefined,

  detalheLoteDto: values.detalheLoteDto?.map((detalheLoteDto) => {

    return {
      id: detalheLoteDto?.id || undefined,
      gtinEan: detalheLoteDto?.gtinEan,
      sku: detalheLoteDto?.sku || "",
      gpc: detalheLoteDto?.gpc || "",
      descricao: detalheLoteDto?.descricao,
      categoria: detalheLoteDto?.categoria,
      lote: detalheLoteDto?.lote || "",
      unidades: detalheLoteDto?.unidades
        ? Number(detalheLoteDto?.unidades)
        : undefined,
      urlImagens: detalheLoteDto?.urlImagens,
      quantidadePorCaixa: detalheLoteDto?.quantidadePorCaixa
        ? Number(detalheLoteDto?.quantidadePorCaixa)
        : undefined,
      peso: detalheLoteDto?.peso,
      dimessaoCaixa: detalheLoteDto?.dimessaoCaixa,
      caixaPallet: detalheLoteDto?.caixaPallet,
      loteMinimo: detalheLoteDto?.loteMinimo,
      tipoFrete: detalheLoteDto?.tipoFrete,
      precoUnidade: detalheLoteDto?.precoUnidade
        ? Number(detalheLoteDto?.precoUnidade)
        : undefined,
      precoDisplay: detalheLoteDto?.precoDisplay
        ? Number(detalheLoteDto?.precoDisplay)
        : undefined,
      precoCaixa: detalheLoteDto?.precoCaixa
        ? Number(detalheLoteDto?.precoCaixa)
        : undefined,
      precoConsumidor: detalheLoteDto?.precoConsumidor
        ? Number(detalheLoteDto?.precoConsumidor)
        : undefined,
      precoTotalLote: detalheLoteDto?.precoTotalLote
        ? Number(detalheLoteDto?.precoTotalLote)
        : undefined,
      precoMinimo: detalheLoteDto?.precoMinimo
        ? Number(detalheLoteDto?.precoMinimo)
        : undefined,
      descontoMaximo: detalheLoteDto?.descontoMaximo
        ? Number(detalheLoteDto?.descontoMaximo)
        : undefined,
      estoqueDisponivelCaixas: detalheLoteDto?.estoqueDisponivelCaixas
        ? Number(detalheLoteDto?.estoqueDisponivelCaixas)
        : undefined,
      pedidoMinimo: detalheLoteDto?.pedidoMinimo
        ? Number(detalheLoteDto?.pedidoMinimo)
        : undefined,
      estadoDestino: detalheLoteDto?.estadoDestino || undefined,
      valorSubstTributaria: detalheLoteDto?.valorSubstTributaria
        ? Number(detalheLoteDto?.valorSubstTributaria)
        : undefined,
      precoVenda_NF_PorCaixa: detalheLoteDto?.precoVenda_NF_PorCaixa
        ? Number(detalheLoteDto?.precoVenda_NF_PorCaixa)
        : undefined,
      observacoes: detalheLoteDto?.observacoes,
      motivoOfertaId: detalheLoteDto?.motivoOferta ?? detalheLoteDto?.motivoOfertaId ?? null,
      outro: detalheLoteDto?.outro,
      dataValidade: detalheLoteDto?.dataValidade,
      descontoAplicado: detalheLoteDto?.descontoAplicado,
      feeGreenersPrecoMedioVarejo: detalheLoteDto?.feeGreenersPrecoMedioVarejo,
      markup: detalheLoteDto?.markup,
      precoUnitarioFee: detalheLoteDto?.precoUnitarioFee,
      valorEconomia: detalheLoteDto?.valorEconomia,
      feeGreeners: detalheLoteDto?.feeGreeners
        ? Number(detalheLoteDto?.feeGreeners)
        : undefined,
      localizacaoCarga: detalheLoteDto?.localizacaoCarga.map((localizacaoCarga) => ({
        id: localizacaoCarga?.id || undefined,
        localizacao: localizacaoCarga?.localizacao,
        cidade: localizacaoCarga?.cidade,
        estado: localizacaoCarga?.estado,
        quantidade: localizacaoCarga?.quantidade
          ? Number(localizacaoCarga?.quantidade)
          : undefined,
      }))
    };
  }),
});
